import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { AppIcons } from '@1js/acui-icons';
import { ControlInMenuRendererFunction } from '@1js/acui-menu';

import { AppControlProps, ControlRendererFunction } from '../controls';
import {
  getDefaultCheckBoxRenderer,
  getDefaultComboBoxRenderer,
  getDefaultFontPickerRenderer,
  getDefaultFontStylesPreviewGalleryRenderer,
  getDefaultIconPreviewGalleryRenderer,
  getDefaultLabelRenderer,
  getDefaultRibbonButtonRenderer,
  getDefaultRibbonFlyoutAnchorRenderer,
  getDefaultRibbonInputRenderer,
  getDefaultRibbonSliderRenderer,
  getDefaultRibbonToggleButtonRenderer,
  getDefaultSpinButtonRenderer,
  getDefaultSplitButtonRenderer,
  getDefaultTableStylesPreviewGalleryRenderer,
} from './ControlRenderers';

export const getDefaultRibbonControlRendererFunction = memoizeFunction(
  (appIcons: AppIcons, controlInMenuRendererFunction: ControlInMenuRendererFunction): ControlRendererFunction => {
    // TASK 2547546
    // We need to evaluate how other controls besides the ribbon will deal with focus
    // as we might have to refactor the models for us to set shouldTakeFocus to avoid setting
    // the values here
    return (props: AppControlProps) => {
      switch (props.type) {
        case 'AppButtonProps':
          return getDefaultRibbonButtonRenderer()({
            ...props,
            shouldTakeFocus: props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true,
          });
        case 'AppToggleButtonProps':
          return getDefaultRibbonToggleButtonRenderer()({
            ...props,
            shouldTakeFocus: props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true,
          });
        case 'AppFlyoutAnchorProps':
          return getDefaultRibbonFlyoutAnchorRenderer(appIcons, controlInMenuRendererFunction)(props);
        case 'AppLabelProps':
          return getDefaultLabelRenderer()(props);
        case 'AppSplitButtonProps':
          return getDefaultSplitButtonRenderer(
            appIcons,
            controlInMenuRendererFunction
          )({
            ...props,
            shouldTakeFocus: props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true,
          });
        case 'AppComboBoxProps':
          return getDefaultComboBoxRenderer(appIcons)(props);
        case 'AppFontPickerProps':
          return getDefaultFontPickerRenderer(appIcons)(props);
        case 'AppSpinButtonProps':
          return getDefaultSpinButtonRenderer(appIcons)(props);
        case 'AppCheckboxProps':
          return getDefaultCheckBoxRenderer(appIcons)(props);
        case 'RibbonTableStylesPreviewGalleryProps':
          return getDefaultTableStylesPreviewGalleryRenderer(appIcons, controlInMenuRendererFunction)(props);
        case 'AppFontStylesPreviewGalleryProps':
          return getDefaultFontStylesPreviewGalleryRenderer(appIcons, controlInMenuRendererFunction)(props);
        case 'AppIconPreviewGalleryProps':
          return getDefaultIconPreviewGalleryRenderer(appIcons, controlInMenuRendererFunction)(props);
        case 'AppSliderProps':
          return getDefaultRibbonSliderRenderer()(props);
        case 'AppInputProps':
          return getDefaultRibbonInputRenderer()(props);
        default:
          throw new Error('The following AppControlProps is not valid as a top level ribbon control' + props.type);
      }
    };
  }
);
